import React from "react";
import { Box } from "@mui/material";
import AEEventDetails from "./AEEventDetails";
import AEEventDiningDetails from "./AEEventDiningDetails";
import AEEventRoomDetails from "./AEEventRoomDetails";
import AEEventServiceDetails from "./AEEventServiceDetails";

function AEEventForm({ tabIndex,arrived }) {
 
  return (
    <Box>
      <AEEventDetails tabIndex={tabIndex} arrived={arrived}/>
      <AEEventDiningDetails tabIndex={tabIndex} />
      <AEEventRoomDetails tabIndex={tabIndex} />
      <AEEventServiceDetails tabIndex={tabIndex} />
    </Box>
  );
}

export default AEEventForm;